import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AdminServiceService } from '../../service/admin-service.service';
import { BolsaService } from 'src/app/generales/services/bolsa.service';
import { FileService } from 'src/app/services/file.service';
import { PaisService } from 'src/app/generales/services/pais.service';
import { UiService } from '../../service/ui.service';
import { ProductListComponent } from 'src/app/generales/components/product-list/product-list.component';

@Component({
  selector: 'app-create-multinivel',
  templateUrl: './create-multinivel.component.html',
  styleUrls: ['./create-multinivel.component.scss'],
})
export class CreateMultinivelComponent implements OnInit {
  @ViewChild('productList') productList: ProductListComponent;

  public fields = [];
  public multiGroup: UntypedFormGroup = undefined;
  public id = undefined;
  private _search = '';
  private _range = '';
  private _userId = '';
  private _savedForm = undefined;
  public sending = false;

  constructor(
    private fb: UntypedFormBuilder,
    private adminSv: AdminServiceService,
    private bolsaSv: BolsaService,
    private fileSv: FileService,
    private paisSv: PaisService,
    private uiSv: UiService
  ) { }

  ngOnInit() {
    const obj: any = [
      [ { id: [ '', [Validators.required]] }, 'Nombre', 'id', 'select', '', true ],
      [ { country: [ '', [Validators.required]] }, 'Pais', 'country', 'select' ],
      [ { state: [ '', [Validators.required]] }, 'Estado', 'state', 'select' ],
      [ { city: [ '', [Validators.required]] }, 'Ciudad', 'city', 'select' ],
      [ { range: [ '' ] }, 'Rango', 'range', 'select', 'Seleccione' ],
      [ { rangeTop: [ '' ] }, 'Rango superior', 'rangeTop', 'select', 'Seleccione' ],
      [ { parent: [ '' ] }, 'Nombre rango superior', 'parent', 'select', 'Vendedor', true ],
    ]

    let controls = {};
    this.fields = obj.map(data => { 
      controls = { ...controls, ...data[0] } 
      return { 
        label: data[1], 
        control: data[2], 
        type: data[3], 
        options: [], 
        placeholder: data[4] || '',
        showing: false,
        search: data[5] || false
      };
    })
    this.getRanges();
    this.getUsers('id');

    // LOCALIDAD

    this.getCountries();

    this.multiGroup = this.fb.group(controls);
  }

  async save(){
    this.sending = true;
    await this.adminSv.post(this.multiGroup.value, 'superUser', 'update');
    this.multiGroup.reset();
    await this.uiSv.showToast('Guardado éxitosamente');
    this.sending = false;
    this.productList.reload();
  }

  async getCountries(){
    const countries = await this.bolsaSv.getCountries();
    const control = this.fields.find(x => x.control === 'country');
    control.options = countries.map(country => { return { name: country.name, value: country.iso } } );
  }

  async setValue(ev, field){
    if(field.control === 'country'){
      await this.setStates(ev);
    } else if (field.control === 'state'){
      await this.setCities(ev);
    } else if (field.control === 'rangeTop'){
      if(this._range) this.multiGroup.get('parent').setValue(undefined);
      this._range = ev.detail.value;
      await this.getUsers('parent', null);
    }
  }

  async setStates(ev){
    try{
      const id = ev.detail.value;
      if(!id) return false;
      const countryId = this.paisSv.countrys.find(x => x.code === id).id;
      const states = await this.bolsaSv.getCities(countryId);
      const control = this.fields.find(x => x.control === 'state');
      control.options = states.map(state => { return { name: state.name, value: state.id } });
    }catch(err){
      return;
    }
  }

  async setCities(ev){
    try{
      const id = ev.detail.value;
      if(!id) return false;
      const cities = await this.bolsaSv.getSectors(id);
      const control = this.fields.find(x => x.control === 'city');
      control.options = cities.map(city => { return { name: city.name, value: city.id } });
      this.multiGroup.get('city').reset();
      this.multiGroup.get('city').setValue(Number(this._savedForm.city));
    }catch(err){
      return;
    }
  }

  async getUsers(controlId, userId?){
    const params = {
      search: this._search,
      range: controlId === 'id' ? '' : this._range,
      userId: userId ?? this._userId
    }
    
    const res: any = await this.adminSv.get('superUser/index', '', params);
    const control = this.fields.find(x => x.control === controlId);
    const data = res.data.map(x => { return { value: x.id, name: x.name } });
    control.options = data;
    return data;
  }

  async getRanges(){
   
    const res: any = await this.adminSv.get('range/index', '', '');
    const range = this.fields.find(x => x.control === 'range');
    const rangeSup = this.fields.find(x => x.control === 'rangeTop');
    range.options = res.data.map(x => { return { name: x.name, value: x.id } });
    rangeSup.options = res.data.map(x => { return { name: x.name, value: x.id } });
  }

  setSearch(search, field){
    if(field.search){
      const control = this.fields.find(x => x.control === field.control);
      if(control.control === 'id' || control.control === 'parent'){
        this._search = search;
        this.getUsers(control.control);
      }
    }

  }

  async edit({ product, action, changeAction }){
    try{
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction }, 
        this.id, 
        'superUser', 
        'Usuario', 
        this._savedForm
      );
      this.id = id;
      this._savedForm = undefined;
      if(action !== 'delete'){
        this.multiGroup.reset();
        (savedForm && savedForm.existence === null) ? savedForm.existenceNull = false : savedForm.existenceNull = true;
        if(savedForm.video === 'null'){
          savedForm.video = null;
        }
        savedForm.state = Number(savedForm.state);
        savedForm.city = Number(savedForm.city);
        savedForm.rangeTop = savedForm?.parentUser?.range || undefined;
        savedForm.parent = savedForm?.parentUser?.id || undefined;
        this._savedForm = savedForm;
        this._range = '';
        this._userId = savedForm.id;
        await this.getUsers('id');
        const control = this.fields.find(x => x.control === 'parent');
        control.options = [];
        this.multiGroup.patchValue(savedForm);
      }
    }catch(err){
      console.error(err);
    }
  }

  trackByItems(index, item){
    return item.value;
  }


}
